import { Box, CircularProgress, makeStyles, Typography } from '@material-ui/core';
import moment from 'moment';
import React from 'react';
import { Scrollbars } from 'react-custom-scrollbars';
import { ITransactionHistory } from '../../models/Inquiry/TransactionHistory/ITransactionHistory';
import { IDebtor } from '../../models/Reports/IDebtor';
import { useGlobalState } from '../../store/GlobalStore';

const useStyles = makeStyles((theme) => ({
    root: {
        border: "2px solid black",
        borderRadius: 8,
        height: "90%",
        marginTop: "7px"
    },
    boxView: {
        margin: '0px',
        color: "blue"
    },
    norecord: {
        color: "red",
        fontSize: 15
    },
    history: {
        color: "#009900",
        fontSize: 14
    }
}))

const ReportTransactionAuditHistory: React.FC<{ debtors: IDebtor, transactions: ITransactionHistory[], mapped: boolean }> = (props) => {
    const { transactions } = props;
    const { state, dispatch } = useGlobalState();
    const classes = useStyles();

    const useProgressStyles = makeStyles((theme) => ({
        root: {
            position: 'relative',
        },
        bottom: {
            color: theme.palette.grey[theme.palette.type === 'light' ? 200 : 700],
        },
        top: {
            color: '#1a90ff',
            animationDuration: '550ms',
            position: 'absolute',
            left: 0,
        },
        circle: {
            strokeLinecap: 'round',
        },
    }));

    function Progress(props) {
        const classes = useProgressStyles();
        return (
            <div className={classes.root}>
                <CircularProgress
                    variant="determinate"
                    className={classes.bottom}
                    size={40}
                    thickness={4}
                    {...props}
                    value={100}
                />
                <CircularProgress
                    variant="indeterminate"
                    disableShrink
                    className={classes.top}
                    classes={{
                        circle: classes.circle,
                    }}
                    size={40}
                    thickness={4}
                    {...props}
                />
            </div>
        );
    }

    return (
        <React.Fragment >
            <h4 className={classes.boxView}> Transactions</h4>
            <Box p={1} width="100%" flexShrink={0} bgcolor="white" className={classes.root} >
                <Scrollbars autoHide
                    autoHideTimeout={1000}
                    autoHideDuration={10}
                    autoHeight
                    autoHeightMin={135}
                    autoHeightMax={135}
                    style={{ width: "100%" }}>
                    {transactions.length > 0 ?
                        transactions.map((transactionsHistories) => {
                            if (transactionsHistories.activityType !== "0") {
                                return (
                                    < Typography gutterBottom className={classes.history}>
                                        <p>{moment(transactionsHistories.activityDt).format(state.GlobalUtils?.settingValue)}
                                            &nbsp; {transactionsHistories.activity}
                                        </p>
                                    </Typography>
                                )
                            }
                            else {
                                return (
                                    < Typography variant="h6" gutterBottom className={classes.norecord}>
                                        No Records to Display
                                    </Typography>
                                )
                            }
                        })
                        : <Progress />
                    }
                </Scrollbars>
            </Box>
        </React.Fragment >
    )
}

export default ReportTransactionAuditHistory
